/* @flow */

import * as React from 'react';
import {Helmet} from 'react-helmet';

import {useResizeObserver} from 'shells/utils/hooks';

import {MainHeader} from '../signup/main-header';

import loginData from './login';
import {WhatsNew} from './whats-new';

import './new-login-layout.module.css';

type ReadMore = {
    fullText: string,
    linkText: string,
    url: string,
};

export type LoginData = {
    title: string,
    featureSectionTitle: string,
    features: {url: string, text: string}[],
    readMore: ReadMore,
};

type Props = {|form: React.Node|};

export function NewLoginLayout(props: Props) {
    const [headerRef, setHeaderRef] = React.useState(null);
    const data: LoginData = loginData;

    // done to allow us to align the header and whats new content
    // left edges with one another while still remaining centered
    // overall in the column
    const [headerWidth] = useResizeObserver(headerRef);

    return (
        <div styleName='grid-container'>
            <Helmet>
                <meta name='viewport' content='width=device-width,initial-scale=1' />
            </Helmet>
            <div styleName='grid'>
                <div styleName='main-header'>
                    <MainHeader showSignupLink={true} />
                </div>
                <div styleName='header'>
                    <div ref={(ref) => setHeaderRef(ref)} className='width-fit-content'>
                        {data.title}
                    </div>
                </div>
                <div styleName='whats-new'>
                    <div style={{width: headerWidth}}>
                        <WhatsNew />
                    </div>
                </div>
                <div styleName='form'>{props.form}</div>
            </div>
        </div>
    );
}
